import * as React from 'react';
import { Calendar, CalendarProps, CalendarSelectionMode } from 'primereact/calendar';
import clsx from 'clsx';
import styles from './NewCalendar.module.css';
import { ViewportCalendar } from '../ViewportCalendar/ViewportCalendar';

type AnyCalendarProps = CalendarProps<"single", Date> | CalendarProps<"range", Date[]> | CalendarProps<"multiple", Date[]>;

type NewCalendarProps = AnyCalendarProps & {
  keepInViewport?: boolean;
  ref?: React.Ref<Calendar<CalendarSelectionMode>>;
};

export const NewCalendar: React.FC<NewCalendarProps> = ({ className, panelClassName, ...props }) => (
  <ViewportCalendar<CalendarSelectionMode>
    className={clsx(styles.calendar, className)}
    panelClassName={clsx(styles.panel, panelClassName)}
    {...props}
  />
);
